import * as React from "react";
import {
  List,
  Datagrid,
  TextField,
  DateField,
  EmailField,
  Show,
  SimpleShowLayout,
  TopToolbar,
  ShowButton,
  useRecordContext,
} from "react-admin";
import { Box } from "@mui/material";

// LISTA
export const ContactList = () => (
  <List sort={{ field: "created_at", order: "DESC" }} perPage={25}>
    <Datagrid rowClick="show">
      <TextField source="id" />
      <EmailField source="email" />
      <TextField source="phone" />
      <TextField source="reason" />
      {/* preview breve del messaggio */}
      <TextField source="message" />
      <DateField source="created_at" showTime />
      <ShowButton />
    </Datagrid>
  </List>
);

// SHOW (dettaglio completo)
const ContactShowActions = () => <TopToolbar />;

const MessageBlock = () => {
  const record = useRecordContext();
  if (!record) return null;

  return (
    <Box
      sx={{
        whiteSpace: "pre-wrap",
        border: "1px solid",
        borderColor: "divider",
        borderRadius: 2,
        p: 2,
      }}
    >
      {record.message}
    </Box>
  );
};

export const ContactShow = () => (
  <Show actions={<ContactShowActions />}>
    <SimpleShowLayout>
      <TextField source="id" />
      <EmailField source="email" />
      <TextField source="phone" />
      <TextField source="reason" />
      <DateField source="created_at" showTime />
      <MessageBlock />
    </SimpleShowLayout>
  </Show>
);
